export const DONE_VISITS_FILTER_SUBMITTED_ANALYTICS =
  'agentsPwa/DoneVisits/Dialog/DONE_VISITS_FILTER_SUBMITTED_ANALYTICS';

export const DONE_VISITS_FILTERS_STORE_PATH = 'visits';
